// src/TestPage.js

import React from 'react';

function TestPage() {
  return (
    <div style={{ padding: '2rem' }}>
      <h2>Sentry Error Test Page</h2>
      <button
        onClick={() => {
          throw new Error('This is your first error!');
        }}
        style={{
          padding: '1rem',
          fontSize: '1rem',
          background: 'crimson',
          color: 'white',
          border: 'none',
          borderRadius: '5px',
        }}
      >
        Break the World
      </button>
    </div>
  );
}

export default TestPage;
